<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_label_search')"
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
            <b-button-group>
              <!-- <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                v-if="allow('A')"
                @click="$emit('purchaseInbound')"
              >
                <b-icon-plus></b-icon-plus>
                {{ $l('btn_purchaseInbound') || '采购入库' }}
              </b-button> -->
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                v-if="allow('B')"
                @click="$emit('directInbound')"
              >
                <b-icon-plus></b-icon-plus>
                {{ $l('btn_directInbound') || '直接入库' }}
              </b-button>
            </b-button-group>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <dict-select
                v-model="form.listHxFtyInboundStatus"
                url="/sys/common/dict/system"
                :body="statusParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_hxFtyInboundNo') || '入库单号'"
            >
              <el-input
                v-model="form.hxFtyInboundNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="$l('form_label_hxPurchaseNo') || '采购单号'">
              <el-input
                v-model="form.hxPurchaseNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_hxFtyNoticeInNo') || '入库通知单号'"
            >
              <el-input
                v-model="form.hxFtyNoticeInNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm') || '工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_ecomWarehouse') || '入库仓库'">
              <dict-select
                v-model="form.listEcomWarehouseCode"
                url="/ecom/warehouse/cn/warehouse/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                size="mini"
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_buyer') || '采购人员'">
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item
                :label="$l('form_label_totalAmount') || '总入库金额'"
              >
                <br />
                <el-col :span="8">
                  <el-input-number
                    v-model="form.totalAmountStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    size="mini"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.totalAmountEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    size="mini"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.currencyUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'currencyUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    filterable
                    clearable
                    size="mini"
                    style="width:100%"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_inboundDate') || '入库日期'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.inboundDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.inboundDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listHxFtyInboundStatus: ['N', 'Y'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      statusParams: { dictType: 'hxFtyInboundStatus' },
      choosePtyPurchaseVisible: false,
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
